import { Argv } from 'yargs'

export const handler = (): null => null
export const command = 'fastlane <command>'
export const description = 'execute commands related to fastlane'
export const builder = (yargs: Argv): Argv => yargs.commandDir('fastlane-commands')
